import { render, staticRenderFns } from "./StudentHistorySidebar.vue?vue&type=template&id=53a3e4e8&scoped=true&lang=pug&"
import script from "./StudentHistorySidebar.vue?vue&type=script&lang=ts&"
export * from "./StudentHistorySidebar.vue?vue&type=script&lang=ts&"
import style0 from "./StudentHistorySidebar.vue?vue&type=style&index=0&id=53a3e4e8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a3e4e8",
  null
  
)

export default component.exports